
import { useAnalyticsQuery } from './analytics/useAnalyticsQuery';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Main hook for analytics data with React Query caching
 * This provides automatic caching and optimized performance
 */
export const useAnalyticsData = (
  selectedRange: number, 
  userId: string | undefined, 
  authFilter: AuthFilter = 'all'
) => {
  return useAnalyticsQuery(selectedRange, userId, authFilter);
};
